import { Component, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { LayoutBase } from '@app2/core/layout/layout.base';
import { BottomBarComponent } from '@app2/core/components/bottom-bar/bottom-bar.component';
import { Store } from '@ngrx/store';
import { userSelectors } from '@store/user';
import { IconComponent } from '@app2/shared/components/icon/icon.component';
import { FapsStore } from '@app2/store/faps/faps.store';
import { AsideBarComponent } from '@app2/core/components/aside-bar/aside-bar.component';
import { SearchWidgetComponent } from '@app2/features/search-widget/search-widget.component';
import { sessionSelectors } from '@store/session';
import { FooterComponent } from '@app2/core/components/footer/footer.component';

@Component({
  selector: 'sens-faps-layout',
  imports: [
    RouterOutlet,
    BottomBarComponent,
    AsideBarComponent,
    IconComponent,
    RouterLink,
    SearchWidgetComponent,
    FooterComponent,
  ],
  templateUrl: './faps.layout.html',
  styleUrl: './faps.layout.scss',
  standalone: true,
})
export class FapsLayoutComponent extends LayoutBase  {

  private readonly fapsStore = inject(FapsStore);

  private readonly store = inject(Store);

  volume = this.fapsStore.player.muted;

  user = this.store.selectSignal(userSelectors.selectUserData);

  isSetUser = this.store.selectSignal(sessionSelectors.selectIsSetUser);

  onVolumeChange(): void {
    this.fapsStore.changeVolume(!this.volume());
  }

  onLogoClick() {
    this.fapsStore.loadByQuery({ p:1, defaultList: true });
  }
}
